<template>
  <div v-if="state.startWizard">
    <StartWizardTab>
      <button
        data-cy="wizard-intro-continue-btn"
        @click="state.startWizard = false"
        type="button"
        class="btn btn-primary mx-auto"
      >
        Continue
      </button>
    </StartWizardTab>
  </div>
  <div class="container" v-if="!state.startWizard">
    <div class="steps">
      <template v-for="(step, i) in wizard.steps" :key="i">
        <div class="step">
          <div
            :class="[
              'step-icon-bar',
              {
                'stepper-on':
                  i < wizard.steps.indexOf(wizard.step) ||
                  (i === wizard.steps.indexOf(wizard.step) && wizard.showModal)
              }
            ]"
          >
            <div
              :class="[
                'step-icon',
                {
                  'clickable-step':
                    i < wizard.steps.indexOf(wizard.step) ||
                    step.finished() ||
                    wizard.steps[i - 1]?.finished(),
                  'current-tab': step === wizard.step
                }
              ]"
              @click="
                {
                  if (
                    i < wizard.steps.indexOf(wizard.step) ||
                    step.finished() ||
                    wizard.steps[i - 1]?.finished()
                  )
                    wizard.step = step;
                }
              "
            >
              <v-icon :size="$vuetify.display.smAndDown ? 'x-small' : undefined">{{
                step.finished() &&
                (i < wizard.steps.indexOf(wizard.step) ||
                  (wizard.showModal && i === wizard.steps.length - 1))
                  ? "mdi-check"
                  : step.icon
              }}</v-icon>
              <div class="text">
                <!-- <div>{{ step.title }}</div> -->
                {{ step.title }}
                <!-- <div v-if="i < wizard.steps.length - 1" class="bar-spacer"></div> -->
              </div>
            </div>
            <div v-if="i < wizard.steps.length - 1" :class="['stepper-space']"></div>
          </div>
        </div>
      </template>
    </div>
    <div class="tabs-con">
      <SchoolsTab v-if="wizard.step.component === 'SchoolsTab'"></SchoolsTab>
      <EventTab v-if="wizard.step.component === 'EventTab'"></EventTab>
      <DaysTab v-if="wizard.step.component === 'DaysTab'"></DaysTab>
      <BreaksTab v-if="wizard.step.component === 'BreaksTab'"></BreaksTab>
      <SchedulesTab v-if="wizard.step.component === 'SchedulesTab'"></SchedulesTab>
    </div>
    <div class="tab-actions">
      <div>
        <v-btn
          :disabled="wizard.step === wizard.steps[0] || wizard.loading"
          @click="wizard.step = wizard.steps[wizard.steps.indexOf(wizard.step) - 1]"
          variant="outlined"
          >Back</v-btn
        >
      </div>
      <div v-if="wizard.step.component === 'DaysTab' && !wizard.step.finished()">
        <v-btn @click="wizard.saveDay()" data-cy="wizard-day-add-btn">Add</v-btn>
      </div>
      <template v-else>
        <div v-if="wizard.step == wizard.steps.at(-1)">
          <v-btn @click="wizard.submit()" :loading="wizard.loading" data-cy="wizard-submit-btn"
            >Submit</v-btn
          >
        </div>
        <div v-else tabindex="1">
          <v-tooltip activator="parent" location="bottom" v-if="!wizard.step.finished()">
            {{ wizard.step.message }}
          </v-tooltip>
          <v-btn
            data-cy="wizard-next-btn"
            @click="wizard.step = wizard.steps[wizard.steps.indexOf(wizard.step) + 1]"
            :disabled="!wizard.step.finished()"
          >
            Next
          </v-btn>
        </div>
      </template>
    </div>
  </div>
  <SubmitModal></SubmitModal>
</template>

<script setup lang="ts">
import useWizard from "@/stores/school/wizard";
import SubmitModal from "./SubmitModal.vue";
import SchoolsTab from "@/components/school/wizard/SchoolsTab.vue";
import EventTab from "@/components/school/wizard/EventTab.vue";
import DaysTab from "@/components/school/wizard/DaysTab.vue";
import BreaksTab from "@/components/school/wizard/BreaksTab.vue";
import SchedulesTab from "@/components/school/wizard/SchedulesTab.vue";
import StartWizardTab from "@/components/school/wizard/StartWizardTab.vue";
import { reactive } from "vue";
const wizard = useWizard();
const state = reactive({
  startWizard: true
});
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
@use "sass:color";
@use "sass:map";

$custom-gray: #d6d7e0;
$gap: 15px;
$gap-small: 10px;
$gap-x-small: 5px;
$bar-width: 100px;
$bar-width-small: 50px;
$bar-width-x-small: 30px;
$stepper-on-color: $primary-500;
.container {
  padding-top: 30px;
  padding-bottom: 30px;
  border-radius: 10px;
  margin-top: 30px;
  background-color: white;
}
.steps {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: $gap;
  flex-wrap: wrap;

  .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;

    .step-icon-bar {
      display: flex;
      align-items: center;
      gap: $gap;
      .step-icon {
        padding: 10px;
        background-color: $custom-gray;
        border-radius: 100px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.current-tab {
          background-color: color.adjust($custom-gray, $lightness: -15%);
        }
        &:active {
          background-color: color.adjust($custom-gray, $lightness: -5%);
        }
        position: relative;

        .text {
          position: absolute;
          transform: translateX(-50%);
          top: 105%;
          left: 50%;
          width: fit-content;
          // display: flex;
          // gap: $gap;
          color: gray;

          // .bar-spacer {
          //   width: $bar-width;
          // }
        }
      }

      .stepper-space {
        width: $bar-width;
        height: 6px;
        background-color: $custom-gray;
        border-radius: 2px;
      }

      &.stepper-on {
        .stepper-space {
          background-color: $stepper-on-color;
        }

        .step-icon {
          background-color: $stepper-on-color;
          color: white;
        }
      }

      .clickable-step {
        cursor: pointer;
      }
    }
  }
}

.tabs-con {
  margin: auto;
  width: fit-content;
  margin-top: 50px;
  max-width: 100%;
}

.tab-actions {
  display: flex;
  justify-content: space-between;
  max-width: min(1000px, 100%);
  margin: auto;
  margin-top: 30px;
}

@include breakpoints.media-breakpoint-down(md) {
  .steps {
    gap: $gap-small;
    .step {
      .text {
        gap: $gap-small;
        .bar-spacer {
          width: $bar-width-small;
        }
      }
      .step-icon-bar {
        gap: $gap-small;
        .stepper-space {
          width: $bar-width-small;
        }
        .step-icon {
          height: 30px;
          width: 30px;
          padding: 5px;
        }
      }
    }
  }
}
@media only screen and (max-width: 400px) {
  .steps {
    gap: $gap-x-small;
    .step {
      .text {
        gap: $gap-x-small;
        .bar-spacer {
          width: $bar-width-x-small;
        }
      }
      .step-icon-bar {
        gap: $gap-x-small;
        .stepper-space {
          width: $bar-width-x-small;
        }
        .step-icon {
          height: 30px;
          width: 30px;
          padding: 5px;
        }
      }
    }
  }
}
</style>
